export const getUser = store => store.user;
export const getPhones = store => store.contacts.phones;
export const getPortal = store => store.portal;
export const getRoutes = store => store.categories.routes;
export const getCategories = store => store.categories;
export const getProfile = store => store.profileForm;
export const getContacts = store => store.contacts;
export const getSetPasswordForm = store => store.setPasswordForm;
export const getSetEmailForm = store => store.setEmailForm;
export const getRegisterForm = store => store.registerForm;
export const getConfirmPasswordForm = store => store.passwordResetForm;
export const getLoginForm = store => store.loginForm;
export const getForgotForm = store => store.forgotForm;
export const getLoading = store => store.loading.isLoading;
export const getDeleteMeForm = store => store.deleteMeForm;
export const getSettings = store => store.settings;
export const getPathParams = store => store.pathParams;
export const getMenuCategories = store => store.menuCategories;
export const getProducts = store => store.products.products;
export const getNews = store => store.news;
export const getCurrNews = store => store.currNews.news;
export const getCurrProduct = store => store.currProduct.product;
export const getSaleProducts = store => store.saleNewPopular.saleProducts;
export const getNewProducts = store => store.saleNewPopular.newProducts;
export const getPopularProducts = store => store.saleNewPopular.popularProducts;
export const getMyOrders = store => store.myOrders;
export const getMyFirms = store => store.myFirms.firms;
export const getFirmAdd = store => store.firmAdd;
export const getCart = store => store.cart;
export const getShippings = store => store.shippings.shippings;
export const getFavorites = store => store.fav;
export const getQuickRegisterForm = store => store.quickRegisterForm;
export const getFindUserForm = store => store.findUserForm;
export const getCustomer = store => store.customer.customer;
export const getCurrOrder = store => store.currOrder;
export const getResendForm = store => store.resendForm;
export const getNewOrderProducts = store => store.newOrderProducts.newOrderProducts;
